/**
 * Type predicate to ensure a value is of type D
 */
export function isPluginDescription(value) {
    return (value !== null &&
        typeof value === "object" &&
        "id" in value &&
        "type" in value &&
        "name" in value);
}
/**
 * Check if a value is a loadable plugin
 */
export function isLoadablePlugin(value) {
    return (isPluginDescription(value) &&
        "load" in value &&
        typeof value.load === "function");
}
/**
 * Check if a value is a loaded plugin
 */
export function isLoadedPlugin(value) {
    return isPluginDescription(value) && "module" in value;
}
/**
 * Check if a value is a plugin, optionally of a specific type
 * If a type is provided, it will be used to infer the correct plugin type
 */
export function isPlugin(value) {
    return isPluginDescription(value);
}
